module.exports = __webpack_public_path__ + "img/Card_reset.ae091f63.png";